module.exports = __webpack_public_path__ + "static/media/ду.93a81706.mp3";